// extracted by mini-css-extract-plugin
module.exports = {"buttons":"ConfirmModal_buttons__3nw4g","alertIcon":"ConfirmModal_alertIcon__1dTH0"};